/**
 * Numeric source of truth for the z-index scale.
 *
 * MUST stay in sync with `zIndex.module.scss` — that file is the SCSS-side copy, and its `:export`
 * block only resolves under webpack. Jest maps `*.scss` to `identity-obj-proxy`, so reading a value
 * through the module returns the KEY (`'overlay'`), and `Number(...)` of it is `NaN`. Any z-index
 * arithmetic in TS therefore reads from here, never from the stylesheet.
 */ export const zIndexScale = {
    page: 300,
    popover: 550,
    overlay: 1300,
    overlayStride: 4,
    portalledCalendar: 1500,
    dragOverlay: 100010,
    toast: 100020,
    globalLoader: 200000,
    nativeSplash: 200001
};
// WHY: the stride reserves each overlay a private band for the popups it hosts — picker at host + 1, tooltip at host + 2 — so the next overlay to open clears them instead of landing under the picker that spawned it.
export const overlayZIndex = (zIndexOrder)=>zIndexScale.overlay + zIndexOrder * zIndexScale.overlayStride;
